import { themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const EmptyContainer = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${themeGet('spacing.xl')};
`;
